import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

import { StoreProvider } from '@/shared/store/store-context';

/** Store scope: validates the store belongs to the session and provides it to features. */
export const Route = createFileRoute('/_authed/_active/s/$storeId')({
  beforeLoad: ({ context, params }) => {
    const store = context.me.stores.find((s) => s.id === params.storeId);
    if (!store) throw notFound();
    return { store };
  },
  component: StoreLayout,
});

function StoreLayout() {
  const { store } = Route.useRouteContext();
  return (
    <StoreProvider store={store}>
      <Outlet />
    </StoreProvider>
  );
}
